import app from "@/main";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";
import {TaskDurum} from "../../../enum/TaskDurum";

export class MtsOdemeTaskResponse {
    dosyaEsasNo: string = ""
    icraDairesi: string = ""
    message: string = ""
    safahat: any[] = []
}

export class MtsOdemeTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        task.response = new MtsOdemeTaskResponse();
        try {
            let dosya = await app.$uyap.DosyaBul().run(task);
            task.response.dosyaEsasNo = dosya.dosyaNo;
            task.response.icraDairesi = dosya.birimAdi;

            // TDT-3330: "Tebliğ İmkansızlığı"nda tebligatın teslim EDİLMEMİŞ olması sebebin
            // tanımı gereği; bu ön kontrol tam da geçmesi gereken senaryoyu kesiyordu. UYAP
            // portalı da takip başlatmadan önce tebligat listesini hiç sorgulamıyor, sadece
            // kullanıcıdan onay istiyor. Bu sebepte kontrol atlanıyor — kota da harcanmıyor.
            if (task.data.icraTakipSebep?.kod !== "TEBLIG_IMKANSIZLIGI") {
                const tebligatlar = (await app.$uyap.MtsTebligatList().run({dosyaId: dosya.dosyaId})).items;
                const teslimEdildi = tebligatlar.some(tebligat => tebligat.TebligatSonuc == "Tebliğ Edildi");
                if (!teslimEdildi) {
                    task.response.message = "Teslim edilmiş tebligat bulunamadı.";
                    throw new Error(task.response.message);
                }
            }

            const alacaklilar = await app.$uyap.MtsIcraAcilisAlacakliTaraflar().run({dosyaId: dosya.dosyaId});
            if (alacaklilar.taraflarList.length == 0) {
                task.response.message = "Alacaklı Bulunamadı";
                console.log("alacaklilar not found");
                throw new Error("Alacaklı Bulunamadı.")
            }
            let alacakliKisiKurumId = alacaklilar.taraflarList[0].asilTarafIlkKisiKurumId
            const mtsIcraTakipBaslatCevap = await app.$uyap.MtsIcraTakipBaslat().run({
                alacakliKisiKurumId: alacakliKisiKurumId,
                dosyaId: dosya.dosyaId,
                icraTakipSebepId: task.data.icraTakipSebep.id,
                kotaTur: task.data.kotaTur,
                odemeTipi: "7"
            });
            task.response.message = mtsIcraTakipBaslatCevap.message;
            // UYAP bazı redleri 200 + type:"error" ile bildiriyor; UyapRequest yalnızca
            // error+errorCode ikilisi gelince reddediyor. Kontrol edilmezse başarısız işlem
            // yeşil görünür.
            if (mtsIcraTakipBaslatCevap.type === "error")
                throw new Error(mtsIcraTakipBaslatCevap.message);
            task.status = TaskDurum.BITTI_BASARILI;
            return task;
        } catch (e) {
            console.log(e);
            task.response.message = e.message;
            throw new Error(e.message);
        }
    }
}